<span class="tw-tag tw-tag--{{ type }} {{ subtle && 'subtle' }}"><ng-content></ng-content></span>
